// OP-3605 — Leitura das respostas do backend (`{ success, data }`), em
// funções puras para o contrato ficar testável sem SWR.
import { Paginado } from '../../types/estoque'

export const PAGE_SIZE = 50

/** Rotas paginadas: `data = { rows, total, page, lastPage }`. */
export function lerPaginado<T>(body: any): Paginado<T> {
  const d = body?.data ?? {}
  return {
    rows: Array.isArray(d.rows) ? (d.rows as T[]) : [],
    total: Number(d.total) || 0,
    page: Number(d.page) || 1,
    lastPage: d.lastPage == null ? true : Boolean(d.lastPage),
  }
}

/**
 * Rotas que devolvem `data = [...]` já cortado em 50 (ex.: minhas
 * solicitações): não há `total`; a última página é a que veio incompleta.
 */
export function lerLista<T>(body: any, page: number): Paginado<T> {
  const rows = Array.isArray(body?.data) ? (body.data as T[]) : []
  return { rows, total: rows.length, page: Math.max(1, Number(page) || 1), lastPage: rows.length < PAGE_SIZE }
}
